import png from './images/sea_eagles.png'

export const colors = {
  dominant: '#6a003a',
  highlight: '#fff',
}
export const fullname = 'Sea Eagles'
export const badge = png



// WEBPACK FOOTER //
// ./src/nrl-teams/sea-eagles.js